import { render, staticRenderFns } from "./IntroductionLayout.vue?vue&type=template&id=2a8de7ec&scoped=true&"
import script from "./IntroductionLayout.vue?vue&type=script&lang=js&"
export * from "./IntroductionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8de7ec",
  null
  
)

export default component.exports